import { Grid, Typography, TypographyProps } from "@mui/material";
import { useScreenWidthRange } from "../LandingOne";
import styled from "styled-components";
import muiStyled from "@mui/system/styled";

const MainAboutUsSection = () => {
  const isMobile = useScreenWidthRange(0, 768);
  const isTablet = useScreenWidthRange(768, 1024);

  return (
    <SectionContainer
      id={"about-us-section"}
      isMobile={isMobile}
      isTablet={isTablet}
    >
      <GridContainer container>
        <GridItem size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
          <TitleText isMobile={isMobile} isTablet={isTablet}>
            We are Redefining Logistics in <DesktopBreak /> the Digital Age
          </TitleText>
        </GridItem>
      </GridContainer>

      <BottomDecoration />
      <BottomDecoration2 />
    </SectionContainer>
  );
};

type SectionContainerProps = {
  isMobile?: boolean;
  isTablet?: boolean;
};

const SectionContainer = styled.section<SectionContainerProps>`
  width: 100%;
  height: fit-content;
  position: relative;
  background-image: url(${({ isMobile, isTablet }) =>
    isMobile || isTablet
      ? "./assets/img/mobile_ship_background.webp"
      : "./assets/img/ship_wallpaper_about_us_illustration.webp"});
  background-size: cover;
  background-position: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? "center" : "right"};
  display: flex;
`;

const GridContainer = muiStyled(Grid)(({ theme }) => ({
  height: "900px",
  width: "100%",
  background:
    "linear-gradient(180deg, #00286D 50%, rgba(0, 40, 109, 0.00) 80%)",
  padding: "200px 0px 0px",
  [theme.breakpoints.up("lg")]: {
    padding: "0px",
    background:
      "linear-gradient(90deg, #00286D 40%, rgba(0, 40, 109, 0.00) 80%)",
    // height: "766.56px"
  }
}));

const GridItem = muiStyled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100%",
  alignItems: "flex-start",
  display: "flex",
  justifyContent: "center",
  padding: "0px 32px",
  [theme.breakpoints.up("lg")]: {
    alignItems: "center"
  }
}));

interface TitleComps extends TypographyProps {
  isMobile?: boolean;
  isTablet?: boolean;
}

const TitleText = muiStyled(Typography, {
  shouldForwardProp: (prop) => prop !== "isMobile" && prop !== "isTablet"
})<TitleComps>(({ theme, isMobile, isTablet }) => ({
  color: "white",
  fontSize: isMobile || isTablet ? "2.25rem" : "3.25rem",
  maxWidth: isMobile || isTablet ? "100%" : "550px",
  fontFamily: "Switzer",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
  textAlign: "center",
  [theme.breakpoints.up("lg")]: {
    textAlign: "left",
    fontWeight: "500"
  }
}));

const DesktopBreak = styled.br`
  display: none;

  @media (min-width: 767px) {
    display: inline;
  }
`;

const BottomDecoration = styled.div`
  position: absolute;
  bottom: 0;
  width: 66%;
  height: 70px;
  background: white;
  clip-path: polygon(0% 100%, 0% 0%, 80% 100%);
  z-index: 1;

  @media (max-width: 767px) {
    z-index: 1;
    width: 100%;
    height: 95px;
  }
`;

const BottomDecoration2 = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 67.5%;
  height: 110px;
  background: linear-gradient(
    90deg,
    #837bf5 56.04%,
    #817df5 69.14%,
    #00e1ff 100%
  );
  clip-path: polygon(100% 0, 30% 100%, 100% 100%);
  z-index: 0;

  @media (max-width: 767px) {
    width: 100%;
    z-index: 0;
  }
`;

export default MainAboutUsSection;
